import dayjs from 'dayjs';

export function dateInputValue(date) {
  return dayjs(date).format('YYYY-MM-DD');
}

export function normalizeDateInput(value) {
  const s = String(value || '').trim();
  return /^\d{4}-\d{2}-\d{2}$/.test(s) ? s : '';
}

export function parseYmdToDayjs(value) {
  const s = normalizeDateInput(value);
  if (!s) return null;
  const d = dayjs(s);
  return d.isValid() ? d : null;
}

export function formatDayjsToYmd(value) {
  return value?.isValid?.() ? value.format('YYYY-MM-DD') : '';
}
